export interface TokenLifetime {
    idTokenExpiresInSeconds: number;
    refreshTokenExpiresInSeconds: number;
}

export const ID_TOKEN_REFRESH_BUFFER_SECONDS = 600;
